import { Tabs } from '@tonic/shared/components/ui'
import { TabsList } from '@tonic/shared/components/ui'
import { TabsTrigger } from '@tonic/shared/components/ui'
import React from 'react';
import { Outlet } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';

export function ReportsLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { value: 'analytics', label: 'Analytics Dashboard', path: '/reports/analytics' },
    { value: 'standard', label: 'Standard Reports', path: '/reports/standard' },
    { value: 'custom', label: 'Custom Reports', path: '/reports/custom' },
    { value: 'scheduled', label: 'Scheduled Reports', path: '/reports/scheduled' },
    { value: 'sustainability', label: 'Sustainability Metrics', path: '/reports/sustainability' }
  ];

  const currentTab = tabs.find(tab => location.pathname.startsWith(tab.path))?.value || 'analytics';

  return (
    <div className="container mx-auto py-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Reports & Analytics</h1>
        <p className="text-muted-foreground">
          View and manage your business reports and analytics
        </p>
      </div>

      <Tabs value={currentTab} onValueChange={(value) => {
        const tab = tabs.find(t => t.value === value);
        if (tab) navigate(tab.path);
      }}>
        <TabsList>
          {tabs.map(tab => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  );
} 
